// extracted by mini-css-extract-plugin
export default {"text":"style-module--text--8e41c","fixButton":"style-module--fixButton--0d2c7"};